import React from 'react';
import { SharkAuthProvider, useSharkAuth } from '../../context/SharkAuthContext';
import { CommunityLanding } from '../community/CommunityLanding';
import { CommunityDashboard } from '../community/CommunityDashboard';
import { COMMUNITY_BRANDS } from '../community/communityBrands';

const brand = COMMUNITY_BRANDS.shark;

const SharkPageInner = () => {
  const { member, loading } = useSharkAuth();

  if (loading) {
    return (
      <div className="min-h-screen w-full bg-[#0E4D2A] flex items-center justify-center text-[#A8B4A6] font-sans tracking-widest text-sm">
        ...
      </div>
    );
  }

  return member ? (
    <CommunityDashboard brand={brand} useAuth={useSharkAuth} forumPath="/shark/forum" />
  ) : (
    <CommunityLanding brand={brand} useAuth={useSharkAuth} />
  );
};

export const SharkPage = () => (
  <SharkAuthProvider>
    <SharkPageInner />
  </SharkAuthProvider>
);

export default SharkPage;
